import LecomReflux from '../../reflux/lecom_reflux';
import { ModalActions } from '../../realize_overrides/stores/modal_store';
import { ObjectIterator } from '../../utils/object_iterator';
import ScreenSizes from '../../screen_sizes';
import SearcherStoreItem from '../models/searcher_store_item';
import { SearcherEventHandler, SearcherEvents } from '../events/searcher_event_handler';
import LoadSearcherDataActionHandler from '../handlers/load_searcher_data_action_handler';
import SetMappedValuesActionHandler from '../handlers/set_mapped_values_action_handler';
import { formatFieldValue } from '../../form/helpers/field_value_formatter';

export const SearcherActions = LecomReflux.createActions([
	'search',
	'paginate',
	'updateFormValues',
	'openModal',
	'reset'
]);

export const SearcherStore = LecomReflux.createStore({
	listenables: SearcherActions,
	storeItemClass: SearcherStoreItem,
	eventHandler: SearcherEventHandler,
	events: SearcherEvents,
	_uniqueStoreItemId: '',
	store: {},

	postConstruct(storeItem) {
		this._uniqueStoreItemId = storeItem.uniqueStoreItemId;
	},

	onSearch(itemId, filters = {}) {
		const { searcher, page } = this._getStoreItem(itemId);
		const publishEvent = this._publish.bind(this, SearcherEvents.SEARCH, ...arguments);

		this._setProperties(itemId, { page: { ...page, number: 0 }, filterValues: filters, isLoading: false });

		LoadSearcherDataActionHandler.execute(searcher, { filters, page: 0, perPage: page.size})
			.then(this._handleSearchResponse.bind(this, itemId))
			.then(publishEvent);
	},

	onPaginate(itemId, page, perPage) {
		const { searcher, filterValues: filters, page: storePage } = this._getStoreItem(itemId);
		const publishEvent = this._publish.bind(this, SearcherEvents.PAGINATE, ...arguments);

		this._setProperties(itemId, { page: { ...storePage, number: page, size: perPage }});

		LoadSearcherDataActionHandler.execute(searcher, { filters, page, perPage })
		.then(this._handleSearchResponse.bind(this, itemId))
		.then(publishEvent);
	},

	onUpdateFormValues(itemId, data) {
		const { searcher } = this._getStoreItem(itemId);
		const publishEvent = this._publish.bind(this, SearcherEvents.UPDATE_FORM_VALUES, ...arguments);

		SetMappedValuesActionHandler.execute(searcher, data)
		.then(this._postUpdateFormValues.bind(this, itemId))
		.then(publishEvent);
	},

	onOpenModal(action) {
		this.
		_setProperties(this._uniqueStoreItemId, {
			modal: {id: `${action.id}-modal`},
			searcher: action,
			results: [],
			filterValues: {},
			page: { size: 20 },
			isLoading: false
		})
		.then(() => {
			ModalActions.open({ modalId: `${action.id}-modal` });
		});
	},

	onReset(itemId) {
		const { searcher } = this._getStoreItem(itemId);
		searcher.mappings.forEach((mapping) => {
			$(`#input__${mapping.formField.id}__lookup-modal *`).val("");

		});

	},

	/* Private functions */

	_handleSearchResponse(itemId, response) {
		const resources = response.response.entity.content.lookup._embedded && response.response.entity.content.lookup._embedded.lookupValueRows || [];
		const page = response.response.entity.content.lookup.page || {};
		const lookupType = response.response.entity.content.lookupType || '';

		this._setProperties(itemId, { page, results: this._parseLookupResources(resources), isLoading: false, lookupType: lookupType });
		return Promise.resolve();
	},

	_parseLookupResources(resources) {
		if(resources.map == undefined) {
			return [];
		}

		return resources.map((resource) => {
			const parsedResource = {};
			for(let [resourceKey, valueObject] of ObjectIterator.iterate(resource)) {
				parsedResource[resourceKey] = formatFieldValue(valueObject.value);
			}

			return parsedResource;
		});
	},

	_postUpdateFormValues(itemId) {
		if (window.innerWidth <= ScreenSizes.SMALL_SCREEN_WIDTH && !window.importMultipleGridOpen) {
			this._openUpdatedGridFormFieldsModal(itemId);
		}
		return Promise.resolve();
	},

	_openUpdatedGridFormFieldsModal(itemId) {
		const { searcher } = this._getStoreItem(itemId);
		const mappedFields = searcher.mappings ? searcher.mappings.map((mapping) => mapping.formField) : [];

		for(let mappedField of mappedFields) {
			const gridFormParentName = mappedField.gridFormParent;
			if(!!gridFormParentName) {
				ModalActions.open({ modalId: `${gridFormParentName}-modal` });
				break;
			}
		}
	},

});

export default SearcherStore;
